import styled from 'styled-components';

export const BankAccountReconciliationsTable = styled('div')({
  'table td': {
    whiteSpace: 'pre-line',
    padding: '0.25rem 0.75rem',
  },
});
